'use strict'

$ = jQuery

// Specific pages
import Contact from './pages/Contact'
import History from './pages/History'
import Home from './pages/Home'
import Processess from './pages/Processess'
import RegionalPresence from './pages/RegionalPresence'
import Sustainability from './pages/Sustainability'
import Talent from './pages/Talent'
import Products from './pages/Products'

// Wp Components
import Archives from './wp_components/Archives'
import Footer from './wp_components/Footer'
import Header from './wp_components/Header'
import Singles from './wp_components/Singles'

// Shared Components
import Filters from './shared/Filters'
import Lastnews from './shared/Lastnews'
import Share from './shared/Share'
import Sidebar from './shared/Sidebar'

// Tools
import Extras from './tools/Extras'

class Site{
  constructor(){
    // Specific pages
    this.home = new Home()
    this.history = new History()
    this.processess = new Processess()
    this.regional_presence = new RegionalPresence()
    this.talent = new Talent()
    this.sustainability = new Sustainability()
    this.products = new Products()
    this.contact = new Contact()

    // Wp Components
    this.header = new Header({ fixed : true })
    this.archives = new Archives()
    this.singles = new Singles()
    this.footer = new Footer()

    // Shared Components
    this.filters = new Filters()
    this.lastnews = new Lastnews()
    this.share = new Share()
    this.sidebar = new Sidebar()

    $(document).ready(function(){
      let $wrapper = $('#wrapper')
      let $header = $('#header')
      let $layout = $('.Page, .Archive, .Single')
      let $footer = $('.Footer')
      
      if( !$layout.hasClass('Home') ){
        if( $wrapper.outerHeight() + $header.outerHeight() < window.innerHeight ){
          let value = 0

          value += $header.outerHeight()
          value += $footer.outerHeight()
          value = window.innerHeight - value

          if( value > 0 ){
            $layout.css({
              'min-height': value - $layout.outerHeight()
            })
          }
        }
      }

      let $map = $('#map')
      if( $map.length ){
        Extras.mapFuncionality()
      }

      $('#wrapper').siblings('.Sidebar').addClass('-hide_desktop')
      
      let $elem = $('.Page, .Single, .Archive')
      $elem.add( $('.HeaderPage') )
           .on('click', function( event ){
              if( $('#main .Sidebar').length > 0 && $('#main .Sidebar').hasClass('-hover') ){
                $('#main .Sidebar').removeClass('-hover', 300, 'swing')
              }
           })
      
      // Fix for upload form field
      if( $('.upload-wrap').length > 0 ){
        let $inputsFiles = $('.upload-wrap input[type="file"]')

        $inputsFiles.on('change', function( event ){
            let nameFile = $(this)[0].files[0].name,
                label = $(this).siblings('label')

            label.text(nameFile)
        })
      }
    })
  }
}

let site = new Site();


/* -------------------------------------------------------------
  Jobs Manuelita
------------------------------------------------------------- */
$(function($){
	var file,texto;
	$(".adjuntar").on('click', function () {
    file = $(this).parents('.file-input').find('input[type=file].file');
    texto = $(this).find('.valorfile');
    $(file).on('change', function () {
      texto.html(file.val())
      $('.file-input label.adjuntar').removeClass('error-input')
    });
    $(file).trigger( "click");
    return false;
  });

  
  // Dropdown menu header
  let menuHeader = $('.header__navigation__main').find('.menu-item-has-children a');
  
  menuHeader.on('click', function(){
    $('.header__navigation__main .menu-item-has-children').removeClass('mostrar');

    $(this).parent().toggleClass("mostrar")
  })

  $(document).on('click', function(event) {
    var target = event.target;
    
    // Comprobar si el objetivo del clic no es un <li>
    if ( !$(target).is('a') ) {
      // Remover la clase de todos los elementos <li>
      $('.header__navigation__main .menu-item-has-children').removeClass('mostrar');
    }
  });
  
  $('#habeas_data_field_4').on('change', function(_e) {
    $('.habeas_data_pqr_time_msg .hb_pqr_msg').remove();
    
    let days_response = '';
    
    switch ($(this).val()) {
      case 'peticion-consulta':
          days_response = `<p>10 días hábiles contados a partir de la fecha que se recibió la misma.</p>
                           <p>Si no es posible cumplir con este tiempo, se deberá informar al Titular de los datos expresando los motivos y la atención de la consulta debe ser en un tiempo no mayor a 5 días.</p>`;
          break;
      case 'queja-reclamo':
          days_response = `<p>Si el reclamo está incompleto y se requiere información adicional, se le solicitará al Titular información complementaria dentro de los 5 días siguientes a la recepción del reclamo. Si transcurridos 2 meses no se recibe la información completa, se entenderá que ha desistido del reclamo.</p>
                           <p>El tiempo máximo para atender el reclamo es de 15 días hábiles contados a partir del día siguiente a la fecha de su recibo.</p>
                           <p>Si el reclamo no se puede atender en estos 15 días, se debe informar al titular los motivos y se dispondrá de 8 días hábiles siguientes al primer vencimiento.</p>`;
          break;
      default:
          return
    }   
    
    let element = `
        <div class='hb_pqr_msg'>
            <p><b>Tiempo de respuesta</b></p>
            ${days_response}
        </div>`;
    
    $('.habeas_data_pqr_time_msg').append(element);
  })
});